import React from 'react'
import { LeafIcon, SparklesIcon, TruckIcon } from './icons/BenefitIcons'

const benefitsData = [
  {
    icon: <SparklesIcon />,
    title: "Atmosfera Unica",
    description: "Crea un ambiente accogliente e raffinato che distingue il tuo locale dalla concorrenza e stupisce ogni cliente."
  },
  {
    icon: <LeafIcon />,
    title: "Progettazione Su Misura",
    description: "Ogni allestimento è personalizzato per rispecchiare l'identità del tuo locale con essenze selezionate e design esclusivo."
  },
  {
    icon: <TruckIcon />,
    title: "Servizio Completo",
    description: "Dalla progettazione alla realizzazione, dalla manutenzione al restyling. Un servizio chiavi in mano per il tuo business."
  }
]

const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-white scroll-mt-24">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Perché Scegliere i Nostri Allestimenti?</h2>
        <p className="text-lg text-brand-text/70 max-w-2xl mx-auto mb-20">
          Scopri i vantaggi di un allestimento verde professionale che valorizza il tuo locale e migliora l'esperienza dei clienti.
        </p>
        
        <div className="grid md:grid-cols-3 gap-12">
          {benefitsData.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="bg-brand-green/10 text-brand-green rounded-full p-5 mb-6 inline-block">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-semibold text-brand-green mb-3">{benefit.title}</h3>
              <p className="text-brand-text/70 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Benefits